<template>
  <v-dialog
    v-model="show"
    width="400px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h4>Download PDFs</h4>
        <i
          class="el-icon-close"
          @click="changeDialog"></i>
      </div>
      <div class="dialog-body">
        <div
          v-for="(item, i) in list"
          :key="i"
          class="item flex">
          <div class="logo">
            <img :src="item.company_logo">
          </div>
          <div class="content flex">
            <span class="plan">{{item.plan}}</span>
            <span class="price">{{item.premium}}</span>
          </div>
          <div class="download">
            <span
              class="icon flex"
              @click="downloadPdf(item)">
              <font-awesome-icon
                icon="download" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {downloadQuotePdf} from '@/api/quote'
import {downloadFile} from '@/utils/download'
export default {
  name: 'downloadPdf',
  props:{
    list:{
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: false,
    }
  },
  methods: {
    changeDialog(){
      this.show = !this.show
    },

    downloadPdf(item){
      const {class_id, quo_id, url,order_id} = item
      let params = {
        class_id,
        quo_id,
        order_id
      }
      this.network().downloadQuotePdf(url, params)
    },

    network(){
      return {
        downloadQuotePdf: async (url,params) => {
          const res = await downloadQuotePdf(url, params)
          downloadFile(res)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container {
  border-radius: 5px;
  .dialog-header {
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px solid #E1E4E8;
    color: #24292E;
    h4{
      font-weight: 600;
    }
    i{
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .dialog-body{
    padding: 15px;
    .item{
      background: #F6F8FA;
      border-radius: 6px;
      .logo{
        margin: 20px 0 20px 15px;
        img{
          width: 22px;
          height: 22px;
        }
      }
      .content{
        width: 240px;
        margin: 15px;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        span{
          width: 100%;
          line-height: 20px;
        }
        .plan{
          color: #24292E;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
        }
      }
      .download{
        margin: 20px 15px 20px 0;
        .icon{
          width: 48px;
          height: 32px;
          border: 1px solid rgba(27, 31, 35, 0.15);
          box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
          border-radius: 6px;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
    .item + .item{
      margin-top: 20px;
    }
  }
}
</style>
